import {Tags} from 'Event/attendee'
import {
  DOES_NOT_INCLUDE,
  TagsRule,
} from 'Event/attendee-rules/RuleConfig/RuleList/SingleRule/TagsRule'

export function matchesTagsRule(tags: Tags, rule: TagsRule) {
  const hasRuleTag = tags.some((tag) => matchesTag(tag, rule))

  if (rule.type === DOES_NOT_INCLUDE) {
    return !hasRuleTag
  }

  return hasRuleTag
}

export function matchesTag(tag: string, rule: TagsRule) {
  return tag.toLowerCase() === rule.target.toLowerCase()
}
